export default function unauth ({ next, store, nextVue }) {
  if (store.getters['user/isLoggedIn']) {
    return nextVue({ name: 'home' });
  }

  return next();
}
